import { render, staticRenderFns } from "./customer-table-default-indicator.component.vue?vue&type=template&id=7e1c0c42&scoped=true&"
import script from "./customer-table-default-indicator.component.ts?vue&type=script&lang=ts&"
export * from "./customer-table-default-indicator.component.ts?vue&type=script&lang=ts&"
import style0 from "./customer-table-default-indicator.component.scss?vue&type=style&index=0&id=7e1c0c42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1c0c42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
